export default __webpack_public_path__ + "static/media/yshai-merling.70f1d462.png";